// Route constants for navigation and policy pages
export const ROUTES = {
  LANDING: '/landing',
  SELLER_REGISTER: '/seller/register',
  SELLER_LOGIN: '/seller/login',
  USER_REGISTER: '/user/register',
  USER_LOGIN: '/user/login',
  POLICY_CONTACT: '/policy/contact',
  POLICY_SHIPPING: '/policy/shipping',
  POLICY_TERMS: '/policy/terms',
  POLICY_REFUND: '/policy/refund',
  POLICY_PRIVACY: '/policy/privacy',
}; 